/**
 * Metric fields needed to choose a display unit from a unit-system preference.
 */
export type MetricDisplayUnitIds = {
  unitId: string;
  unitUsId?: string | null;
};

/**
 * Picks the Metric Library display unit id for a `unit-system` preference.
 * Uses `unitUsId` when the preference is `us` and a US unit exists; otherwise the canonical `unitId`.
 * @param metric Metric with canonical and optional US display unit ids.
 * @param unitSystem User preference (`metric` | `us`), or null/undefined for canonical.
 * @returns Unit id to store on UserMetric / use for formatting.
 */
export function resolvePreferredDisplayUnitId(
  metric: MetricDisplayUnitIds,
  unitSystem: string | null | undefined,
): string {
  if (unitSystem === 'us' && metric.unitUsId) {
    return metric.unitUsId;
  }
  return metric.unitId;
}
